import React from 'react'
import PropTypes from 'prop-types'
import CustomersHead from "./CustomersHead"
import CustomersBody from "./CustomersBody"
import {Spin} from "antd"

CustomersTable.propTypes = {
    loading: PropTypes.bool,
    error: PropTypes.string,
    listCustomers: PropTypes.array
}

function CustomersTable(props) {
    const {loading, error, listCustomers} = props

    return (
        <div className="CustomersTable">
            <Spin spinning={loading} tip="Đang lấy dữ liệu">
                <table>
                    <CustomersHead/>
                    <CustomersBody {...props} loading={loading} error={error} listCustomers={listCustomers}/>
                </table>
            </Spin>
        </div>
    )
}

export default CustomersTable
